// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicImage_root__ZHT7f","image":"BasicImage_image__FYOSn","imageLink":"BasicImage_imageLink__XAAr_"};